var initialState = {
    isPropertyEditMode: false,
    creationType: 'new',
    allErrorsVisible: false,
    isEditOfPublishedItem: false,
    publishPending: false,
    publishFailed: false,
    publishFailedReasonDisplayText: null,
    publishedItemPendingVip: false,
    publishedItem: null,
    openModal: null,
    openModalData: null,
    autoSaveEnabled: false,
    draftCanBeResumed: false,
    itemUpdating: false,
    itemUpdated: false
};
export default (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case 'RESET_SYI':
            return { ...initialState };
        case 'SET_IS_PROPERTY_EDIT_MODE':
            return { ...state, isPropertyEditMode: action.payload };
        case 'SET_CREATION_TYPE':
            return { ...state, creationType: action.payload };
        case 'SHOW_ALL_ERRORS':
            return { ...state, allErrorsVisible: true };
        case 'HIDE_ALL_ERRORS':
            return { ...state, allErrorsVisible: false };
        case 'SET_IS_EDIT_OF_PUBLISHED_ITEM':
            return { ...state, isEditOfPublishedItem: action.payload };
        case 'SET_PUBLISHED_ITEM_PENDING_VIP':
            return {
                ...state,
                publishedItemPendingVip: action.payload,
                publishedItem: null,
                publishFailed: false,
                publishFailedReasonDisplayText: null,
                publishPending: false,
                publishDelayed: false
            };
        case 'SET_PUBLISHED_ITEM_DELAYED':
            return {
                ...state,
                publishedItemPendingVip: action.payload,
                publishedItem: null,
                publishFailed: false,
                publishFailedReasonDisplayText: null,
                publishPending: false,
                publishDelayed: true
            };
        case 'SET_PUBLISHED_ITEM':
            return {
                ...state,
                publishedItem: action.payload,
                publishedItemPendingVip: null,
                publishFailed: false,
                publishFailedReasonDisplayText: null,
                publishPending: false,
                publishDelayed: false
            };
        case 'SET_PUBLISH_FAILED':
            return {
                ...state,
                publishedItem: null,
                publishedItemPendingVip: null,
                publishFailed: true,
                publishFailedReasonDisplayText: action.reasonDisplayText,
                publishPending: false,
                publishDelayed: false
            };
        case 'SET_PUBLISH_PENDING':
            return {
                ...state,
                publishedItem: null,
                publishedItemPendingVip: null,
                publishFailed: false,
                publishFailedReasonDisplayText: null,
                publishPending: true,
                publishDelayed: false
            };
        case 'RESET_PUBLISH_STATE':
            return {
                ...state,
                publishedItem: null,
                publishedItemPendingVip: null,
                publishFailed: false,
                publishFailedReasonDisplayText: null,
                publishPending: false,
                publishDelayed: false
            };
        case 'SET_CATEGORY_RESTRICTION':
            return { ...state, categoryRestriction: action.payload };
        case 'TOGGLE_MODAL':
            var newValue =
                state.openModal === action.payload ? null : action.payload;
            return { ...state, openModal: newValue };
        case 'SHOW_MODAL':
            return {
                ...state,
                openModal: action.modalId,
                openModalData: action.modalData
            };
        case 'HIDE_MODAL':
            return { ...state, openModal: null };
        case 'ENABLE_AUTOSAVE':
            return { ...state, autoSaveEnabled: true };
        case 'DISABLE_AUTOSAVE':
            return { ...state, autoSaveEnabled: false };
        case 'SET_DRAFT_CAN_BE_RESUMED':
            return { ...state, draftCanBeResumed: action.payload };
        case 'SET_ITEM_UPDATING':
            return { ...state, itemUpdating: action.payload };
        case 'SET_ITEM_UPDATED':
            return { ...state, itemUpdated: action.payload };
        default:
            return state;
    }
};
